import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../i18n/en.js';
import de from '../i18n/de.js';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    resources: {
      en: {
        translation: en
      },
      de: {
        translation: de
      }
    },
    lng: "en",
    fallbackLng: "en",
  
    interpolation: {
      escapeValue: false
    }
  });


export default i18n;